import { Link } from 'react-router-dom';
import { categories } from '@/mocks/films';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
                木瓜影视
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed">
              免费在线观看最新电视剧电影，<br />
              高清不缓冲，即点即播无需下载注册。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/20 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-foreground-950 font-semibold mb-4 text-sm">影视分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-950 font-semibold mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer">
                  热门电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer">
                  最新电影
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-950 font-semibold mb-4 text-sm">联系我们</h4>
            <p className="text-foreground-500 text-sm mb-2">
              邮箱：contact@muguays.com
            </p>
            <p className="text-foreground-500 text-sm mb-2">
              微信：muguays_official
            </p>
            <p className="text-foreground-500 text-sm">
              工作时间：周一至周日 9:00-22:00
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 木瓜影视 muguays.com — 仅供学习交流，不提供下载服务
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}